module.exports = __webpack_public_path__ + "img/sjznyx.a524859b.png";